import { apiGet } from './client';
import { PRODUCT_WIKI_SLUG } from './projects';

export interface BreadcrumbEntry {
  label: string;
  path: string;
}

export interface WikiPageResponse {
  html: string;
  title: string;
  modifiedAt: string;
  breadcrumb: BreadcrumbEntry[];
}

/** Always encode each path segment so titles with slashes/spaces don't break the URL. */
function encodePathSegments(path: string): string {
  return path
    .split('/')
    .filter((s) => s.length > 0)
    .map(encodeURIComponent)
    .join('/');
}

export function getWikiPage(path: string): Promise<WikiPageResponse> {
  return apiGet<WikiPageResponse>(`/${PRODUCT_WIKI_SLUG}/wiki/${encodePathSegments(path)}`);
}

export function getRawPage(path: string): Promise<WikiPageResponse> {
  return apiGet<WikiPageResponse>(`/${PRODUCT_WIKI_SLUG}/raw/${encodePathSegments(path)}`);
}
